import React from 'react'
import { Router, Link } from 'react-static'
import { hot } from 'react-hot-loader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

class Dropdown extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          showMenu: false,
        }

        this.showMenu = this.showMenu.bind(this);
      }

      showMenu(event) {
        event.preventDefault();

        this.setState(prevState => ({
          showMenu: !prevState.showMenu
        }));
      }

  render() {
    return (
        <li className="dropdown">
          <Link to={this.props.mainLink}>{this.props.mainName}</Link>
          <a className="dropdown-icon" onClick={this.showMenu}><FontAwesomeIcon icon={faCaretDown} /></a>
        {
          this.state.showMenu
            ? (
              <ul className="submenu">
                <li><Link to={this.props.subLinkOne}> {this.props.subNameOne} </Link></li>
                <li><Link to={this.props.subLinkTwo}> {this.props.subNameTwo}</Link></li>
              </ul>
            )
            : (
              null
            )
        }
      </li>

    );
  }
}

export default Dropdown



// WEBPACK FOOTER //
// /opt/build/repo/src/components/dropdown.js